import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTopic from '../../../../components/newsTopic';
import ContentTitle from '../../../../components/contentTitle';
import NewsList from '../../../../components/newsList';

class ShopBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { shopTopic, shopTitle, shopList0, shopList1 },
        } = this.props;

        return (
            <div id="shopNewsList" className={styles.shop_box}>
                <Chip id="50084" type="struct" title="财经梧桐汇标题" groupName="财经梧桐汇" content={shopTopic}>
                    <NewsTopic />
                </Chip>
                <Chip
                    id="75124"
                    type="recommend"
                    title="财经梧桐汇头条"
                    groupName="财经梧桐汇"
                    content={shopTitle}
                    translate="handleNewsContentData">
                    <ContentTitle />
                </Chip>
                <Chip
                    id="75125"
                    type="recommend"
                    title="财经梧桐汇新闻列表1"
                    groupName="财经梧桐汇"
                    content={shopList0}
                    translate="handleNewsContentData">
                    <NewsList isList />
                </Chip>
                <Chip
                    id="75126"
                    type="recommend"
                    title="财经梧桐汇新闻列表2"
                    groupName="财经梧桐汇"
                    content={shopList1}
                    translate="handleNewsContentData">
                    <NewsList hasTitle isList />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(ShopBox);
